import Breadcrumb from "../components/Breadcrumb";
import UpdatePlan from "../components/UpdatePlan";
import { useLocation, useParams } from "react-router-dom";

const UpdatePlanPage = () => {
  const { plan_id } = useParams();
  const location = useLocation();
  const plan = location.state?.plan;

  return (
    <>
      <Breadcrumb title="Update Plan" />

      <UpdatePlan plan={plan} plan_id={plan_id} />
    </>
  );
};

export default UpdatePlanPage;
